export default "__VITE_ASSET__DvskEZBl__"